import { ThemeProvider as NextThemesProvider } from 'next-themes';

type NextThemesProps = React.ComponentProps<typeof NextThemesProvider>;

/**
 * Thin wrapper around `next-themes` that also enables the native CSS
 * `color-scheme` (so form controls + scrollbars match the active theme) by
 * default. Callers can still override the `enableColorScheme` prop explicitly.
 */
export function ThemeProvider({ children, enableColorScheme = true, ...props }: NextThemesProps) {
	return (
		<NextThemesProvider enableColorScheme={enableColorScheme} {...props}>
			{children}
		</NextThemesProvider>
	);
}
